module.exports = __webpack_public_path__ + "static/img/solv.0a4abfd7.png";